export default [
  {
    path: '/mng/sharedData',
    name: 'sharedData',
    component: () => import('@/pages/mng/permission/dataRule/App.vue'),
    children: [
      {
        path: '/',
        name: 'sharedDataList',
        component: () => import('@/pages/mng/permission/dataRule/pages/list/index.vue'),
        meta: {
          title: '数据共享设置',
          keepAlive: true,
        },
      },
      {
        path: 'edit/:ruleId',
        name: 'edit',
        component: () => import('@/pages/mng/permission/dataRule/pages/edit/index.vue'),
        meta: {
          title: '数据共享设置',
          noNeedData: true,
        },
      },
      {
        path: 'create',
        name: 'create',
        component: () => import('@/pages/mng/permission/dataRule/pages/edit/index.vue'),
        meta: {
          title: '数据共享设置',
          noNeedData: true,
        },
      },
    ],
  },
];
